import {BasicSelect,MultiSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import Pagination from '../../../shared/components/pagination'
import CustomExpandableTable from '../../../shared/components/customExpandableTable';
import Loader from '../../../shared/components/loader';
import CONSTANT from '../../../shared/constants/constant';
import Util from '../../../shared/util/util';
import XLSX from 'xlsx';
import SupportServices from '../../services/utility.service'
import VueElementLoading from 'vue-element-loading';
const moment = require('moment');

export default {
    name: 'airwallettransaction',
    components: {
        CryptoJS,
        Pagination,
        CustomExpandableTable,
        Loader,
        CONSTANT,
        Util,
        XLSX,
        SupportServices,
        VueElementLoading
    },
    data: function() {
        return{
            isLoading:false,
            awbnumber:'',
            transactionid:'',
            currentPage: 1,
            totalPage: 0,
            totalCount:0,
            offset:0,
            pageLimit:CONSTANT.PER_PAGE_DATA,
            expandableKey: 0,
            tableColumn: ['Transaction ID','AWB','Client Name','Amount','Type',
            'Transaction Req.','Payment Status','Payment Comment','Created Date','Created By','Payment Response','Refund'],
            tableItems:[],
            transactiondetails:'fasle',
            transactiondata:''

        }
    },
    computed: {

    },
    mounted() {
      var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
      var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
      var plaintext = bytes.toString(CryptoJS.enc.Utf8);
      var userdetail = JSON.parse(plaintext);
      this.userdetail = userdetail
      this.defaultHubID = userdetail.hubID[0];
      this.userName = userdetail.email;
      this.searchTransaction()
    },
    methods: {
        async searchTransaction(){
            try{
                this.isLoading = true;
                let inputPayload = {
                    "offset": this.offset,
                    "limit": this.pageLimit,
                }
                if(this.awbnumber){
                    inputPayload.awbnumber = this.awbnumber.trim();
                }
                if(this.transactionid){
                  inputPayload.transactionid = this.transactionid;
                }
                let result = await SupportServices.getTransactionList(inputPayload)
                if(result.data.code == 200){
                    this.tableArr = result.data.data.rows;
                    this.totalCount = result.data.data.count;
                    this.tableItems = result.data.data.rows.map((el)=>{
                        let transaction = el.transactiontype == 1 ? 'Credit':'Debit'
                        let paymentstatus = el.paymentstatus == 1 ? 'Initiated' : el.paymentstatus == 2 ? 'Completed' : 'Failed'
                        return{
                            'id':el.id,
                            'Transaction ID':el.id,
                            'AWB':el.awb,
                            'Client Name':el.clientname+'('+el.clientid+')',
                            'Amount':el.amount,
                            'Type':transaction,
                            'Transaction Req.':el.paymentgatewayrequest,
                            'Payment Status':paymentstatus,
                            'Payment Comment':el.paymentcomment,
                            'Created Date':moment(el.createddate).tz('Asia/Kolkata').format('DD-MM-YYYY HH:mm'),
                            'Created By':el.createdby,
                            'Payment Response':el.paymentstatus == 3 ? true:false,
                            'Refund':el.refundflag
                        }
                    })
                    this.expandableKey += 1
                }else{
                this.totalCount = 0
                this.tableItems = [];
              }
              if (this.totalCount < this.pageLimit) {
                this.totalPage = 1
              } else {
                this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
              }
              this.isLoading = false;
            }catch(err){
                this.isLoading = false;
                console.log("error",err)
            }
        },
        async getCustomTableEvent(id){
            if(id.actionType == "refund"){
                await this.$confirm("Are you sure you want to refund the amount?","","question").then(async result => {
                    if(result){
                        this.isLoading = true
                        let input = {
                            transId : id.id,
                            createdby: this.userName
                        }
                        let result = await SupportServices.airCargoPaymentRevert(input)
                        this.isLoading = false
                        if(result.data.code == 200){
                            this.$alertify.success("Refund Successful.")
                            this.searchTransaction()
                        }else{
                            this.$alertify.error(result.data.message)
                        }
                    }else{
                        console.log("Cancel",result)
                    }
               }).catch((err)=>{
                 console.log(err)
               });
            }else if(id.actionType == 'response'){
                this.isLoading = true;
                let input = {
                    id:id.id
                }
                let result = await SupportServices.getWalletTransationResponse(input)
                this.isLoading = false;
                if(result.data.code == 200){
                    this.transactiondata = ''
                    this.transactiondetails = true
                        this.transactiondata = result.data.data.paymentgatewayresponse
                }else{
                    this.$alertify.error(result.data.message);                }
            }

        },
        onPageChange(page) {
            this.currentPage = page;
            this.offset = (page - 1) * this.pageLimit
            this.searchTransaction();
          },
        resetFilter(){
            this.currentPage = 1;
            this.offset = 0;
            this.awbnumber='',
            this.transactionid=''
            this.searchTransaction()
        },
        closeTransactionDetails() {
            this.transactiondetails = false
          },
    }    
}



// WEBPACK FOOTER //
// ./src/modules/utility/views/airwallettransactions/airwallettransaction.component.js